import { render, staticRenderFns } from "./YouTubeBlock.vue?vue&type=template&id=69841073&scoped=true"
import script from "./YouTubeBlock.vue?vue&type=script&lang=js"
export * from "./YouTubeBlock.vue?vue&type=script&lang=js"
import style0 from "./YouTubeBlock.vue?vue&type=style&index=0&id=69841073&prod&lang=css"
import style1 from "./YouTubeBlock.vue?vue&type=style&index=1&id=69841073&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69841073",
  null
  
)

export default component.exports